import { HTMLProps, useRef } from 'react';
import classNames from 'classnames';
import { FieldInputProps, FieldMetaProps, FormikErrors, useField } from 'formik';
import { nanoid } from 'nanoid';

import { IFormFieldProps } from './models';

interface IUseFormField<T> {
  id: string;
  fieldProps: Pick<HTMLProps<any>, 'className'>;
  inputProps: FieldInputProps<T> & Pick<HTMLProps<any>, 'id' | 'className'>;
  setValue: (value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<T>>;
  meta: FieldMetaProps<T>;
}

export function useFormField<T = any>(name: string, size: IFormFieldProps['size'] = 50): IUseFormField<T> {
  const idRef = useRef(`${name}-${nanoid(6)}`);
  const [input, meta, helpers] = useField<T>(name);

  const className = classNames(`modFormField modFormField--${size}`, {
    'modFormField--error': meta.error && meta.touched,
  });
  return {
    id: idRef.current,
    fieldProps: { className },
    inputProps: { ...input, id: idRef.current, className: 'modFormField__input' },
    setValue: helpers.setValue,
    meta,
  };
}
